import { DataService } from './dataService'
const authServices = {
	login: async (data) => {
		return DataService.post('/admin/login', data)
	},

	registration: async (data) => {
		return DataService.post('/admin/registration' ,data)
	},
	forgot_password: async (data) => {
		return DataService.post('/admin/forgot_password' ,data)
	},
	reset_password: async (data) => {
		return DataService.post('/admin/reset_password' ,data)
	},

}


export default authServices